var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStart1 = function SvgIconStart1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.18 2.297c1.455 0 2.65 1.166 2.65 2.622v14.16c0 1.456-1.195 2.622-2.65 2.622H4.82c-1.455 0-2.65-1.166-2.65-2.622V4.92c0-1.456 1.195-2.622 2.65-2.622zM3.368 19.079c0 .778.643 1.423 1.452 1.423h2.476v-4.87H3.37zm5.128 1.423h7.005v-4.87H8.497zm8.205 0h2.477c.81 0 1.451-.645 1.451-1.423v-3.446h-3.928zM3.369 14.434h8.03v-4.87H3.37zm9.23 0h8.031v-4.87H12.6zM8.497 8.365h7.005V3.496H8.497zm8.205 0h3.928V4.92c0-.778-.642-1.423-1.45-1.423h-2.478zM4.82 3.496c-.81 0-1.452.645-1.452 1.423v3.446h3.928V3.496z"
  })));
};
export default SvgIconStart1;